module.exports = __webpack_public_path__ + "img/img64.968fea8b.png";